export default __webpack_public_path__ + "static/media/Update-Adress.c6f97843.jpg";